module.exports = __webpack_public_path__ + "static/img/來登記300x300.5e3f2fc5.png";